import type { RouteRecordRaw } from 'vue-router';

/**
 * Routes publiques (non auth). Cf wiki §14.13 + sitemap §32.
 * Layout sobre, sans menu, juste header marketing leger.
 */
export const publicRoutes: RouteRecordRaw[] = [
  // Lot 51A — Landing page publique (marketing). Accessible aux non-connectes
  // par redirection depuis / (guard router/index.ts) et a tout le monde via
  // /welcome directement.
  {
    path: '/welcome',
    name: 'landing',
    component: () => import('@/views/public/LandingView.vue'),
    meta: { public: true, layout: 'public' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/public/LoginView.vue'),
    meta: { public: true, layout: 'public' },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/public/RegisterView.vue'),
    meta: { public: true, layout: 'public' },
  },
  {
    path: '/public-universes',
    name: 'public-universes',
    component: () => import('@/views/public/PublicUniversesView.vue'),
    meta: { public: true, layout: 'public' },
  },
  // Pages légales publiques (Mentions légales, CGU, CGV, RGPD, Cookies, Contact).
  // Une seule vue paramétrée par :page (cf LegalView).
  {
    path: '/legal/:page',
    name: 'legal',
    component: () => import('@/views/public/LegalView.vue'),
    meta: { public: true, layout: 'public' },
  },
];
